
import Vue from 'vue';
import moment from 'moment';
import {
  mapGetters, mapActions, mapMutations, mapState,
} from 'vuex';
import Card from '@/components/CardItem/index.vue';
import term from '@/../Term.json';
import Footer from '@/components/Footer/index.vue';
import Header from '@/components/Header/index.vue';
import NotificationBadge from '@/components/NotificationBadge/index.vue';
import ModalAdd from '@/components/ModalAddUser/index.vue';
import Modal from '@/components/Modal/index.vue';
import Checkbox from '@/components/Checkbox/index.vue';
import NotificationCenter from '@/components/NotificationCenter/index.vue';
import Button from '@/components/Button/index.vue';
import getTicket from '@/services/tickets/get-tickets';
import { StartBlip } from '@/utils/StartBlip';
// import { updateStatusTerritoryOfficial } from '@/services/territory/update-status-territory-oficial';
import {
  formatStringOnlyNumbers,
} from '@/utils';
import { sendEmail } from '@/services/email/send-email';
import getDocumentPaliative from '@/services/paliative/get-document';
import putDocumentPaliative from '@/services/paliative/put-document';
import { getContestationAll } from '@/services/contestation/get-contestationAll';
import { insertAppointment } from '@/services/appoinments/insert-appointment';
import { getNotificationRead, getNotificationUnread, GetNotificationParams } from '@/services/notifications/get-notification';
import { getReadNotification } from '@/services/notifications/get-read-notification';
import setAsRead from '@/services/territory-access/setAsRead';
import { insertReadNotification } from '@/services/notifications/insert-read-notification';
import switchNotificationType from '@/utils/switch-status-notification';
import { setReadNotification, SetReadNotificationParams } from '@/services/notifications/set-read-notification';
import getPenalty from '@/services/tickets/get-penalty';
import { generateLinkGix } from '@/services/gix/get-link-gix';
import getUserVoucherAvailability from '@/services/territory-access/get-user-voucher-availability';
import getTerritoryByAgentDocumentService, {
  TerritoryStatus,
} from '@/services/territory/get-territory-by-agent-document';
import {
  NotificationResponseType,
  responseNotification,
  ResponseNotificationParams,
} from '@/services/notifications/response-notification';
import {
  updateSetReadAppointment,
  UpdateSetReadAppointmentParams,
} from '@/services/appoinments/update-set-read-appointment';
import {
  StatusTerritoryAccess,
  StatusTerritoryAccessNumber,
} from '@/config/types';
import {
  Wrapper, Main, Nav, TextP, TextPM,
} from './styles';

export default Vue.extend({
  components: {
    Wrapper,
    Main,
    Nav,
    Header,
    Footer,
    Card,
    NotificationBadge,
    NotificationCenter,
    Modal,
    ModalAdd,
    Checkbox,
    Button,
    TextP,
    TextPM,
  },
  data() {
    return {
      territoriesArray: [] as any,
      componentKey: 0,
      close: false,
      modal: false,
      termChange: false,
      loaded: false,
      dataPenalty: {} as any,
      searchCar: '',
      search: '',
      isReadObj: [] as any,
      isReadObjTicket: [] as any,
      notifications: [] as any[],
      territories: [] as any,
      territoriesCopy: [] as any[],
      idUser: 0,
      openNotificationCenter: false,
      userLoged: JSON.parse(sessionStorage.getItem('userLogged') as string),
      userGroup: '',
      modalAddAgent: false,
      linkImg: '',
      linkGix: '',
      territoryEditionModal: false,
      car: '',
      url: '',
      Termo: term.Term,
      loading: false,
      loadingNotificationCenterNotViewed: false,
      loadingNotificationCenterViewed: false,
      notificationEntity: {} as any,
      notificationCount: 0,
      label: {
        title: 'name',
        subTitle: 'city',
      },
      actions: [
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        { icon: 'Info', text: 'Ver mais', click: this.moreDetails },
      ],
      territoriesImagesUrl: [] as string[],
      stepRegisterNotifications: [] as any[],
      isContractionMenu: false,
      cardData: [
        { name: 'Fazenda x', city: 'Local Desconhecido' },
        { name: 'Fazenda y', city: 'Local Desconhecido' },
        { name: 'Fazenda z', city: 'Local Desconhecido' },
      ],
      routes: [
        { name: 'Territórios', path: '/produtor/territory', icon: 'Earth' },
        { name: 'Pagamentos', path: '/produtor/payments', icon: 'Money' },
        // { name: 'Calendário de Monitoramento', path: '/produtor/calendar', icon: 'Calendar' },
        { name: 'Interações', path: '/produtor/interation', icon: 'Interation' },
        {
          name: 'Sair',
          path: '/exit',
          icon: 'Exit',
          line: true,
          // @ts-ignore
          onClick: this.logout,
        },
      ],
      loadingModal: false,
    };
  },
  computed: {
    ...mapState(['appointments']),
    ...mapGetters([
      'notificationData',
      'getNotificationsUnread',
      'getNotificationsRead',
      'DateById',
      'Link',
      'getAppointmentNotification',
      'hasAvaliableVoucher',
      'hasTermsAccept',
    ]),
  },
  methods: {
    ...mapActions({
      changeStatusNotification: 'changeStatusNotification',
      getAppointmentRequest: 'getAppointmentRequest',
      insertDateStatus: 'insertDateStatus',
      getStatusbycdUser: 'getStatusbycdUser',
      getNotificationAppoint: 'getNotificationAppoint',
      getNotificationRead: 'getNotificationsRead',
    }),
    ...mapMutations(['setNotificationUnread', 'setNotificationRead', 'setVoucherUsability', 'setTermsAccept']),
    cleanSearch() {
      this.territories = this.territoriesCopy;
    },
    logout() {
      const blipChat = document.getElementById('blip-chat-container');
      if (blipChat) blipChat.remove();

      sessionStorage.setItem('userLogged', '');
      sessionStorage.setItem('chave', '');
      this.$router.replace('/login');
    },
    closeModal() {
      this.modal = !this.modal;
    },
    copyURL() {
      navigator.clipboard
        .writeText(this.linkGix)
        .then(() => {
          Vue.swal('', 'Link da Sua Jornada no Gix copiado com sucesso!', 'success');
        })
        .catch(() => {
          Vue.swal('', 'Erro ao copiar link', 'error');
        });
    },
    handleOpenNotificationCenter() {
      this.openNotificationCenter = !this.openNotificationCenter;
    },
    changeTerm() {
      this.termChange = !this.termChange;
    },
    goToCalendary() {
      this.$router.push({ name: 'Calender' });
    },
    async Acept() {
      this.loadingModal = true;
      try {
        const termAccepted = {
          cdUser: this.userLoged.idUser.toString(),
          tokenKey: this.userLoged.company.stKey,
          status: 'Aceite',
        };
        if (this.termChange === true) {
          await this.insertDateStatus(termAccepted);
          this.setTermsAccept(true);
          this.modalAddAgent = false;
        }
      } catch {
        Vue.swal('', 'Erro ao salvar o aceite do termo', 'error');
      }
      this.loadingModal = false;
    },
    registerTerritory() {
      if (this.hasAvaliableVoucher && this.hasTermsAccept) {
        this.$router.push('/produtor/register-territory');
      }
    },
    async setRead(value: any) {
      if (value.tag === 'Multa') {
        const { idUser } = this.userLoged;
        const tokenKey = this.userLoged.company.stKey;
        const cdTerritory = value.idTerritory;
        await insertReadNotification(idUser, cdTerritory, tokenKey, true, 'Multa', '');
        this.$router.push(`/produtor/territorio/${value.idTerritory}/${value.name}`);
      }
      const { notificationsUnread } = this.$store.state;
      let isExist = false;
      const resultNotifications = notificationsUnread.map(async (notification: any) => {
        if (notification.id === value && notification.type === 'info') {
          window.open(this.Link.data.objectResult);
        }

        if (notification.id === value) {
          isExist = true;
          await setAsRead({ userType: 'Produtor', territoryAccessIds: [value] });
          return { ...notification, read: true };
        }
        return notification;
      });

      const result = await Promise.all(resultNotifications);

      if (!isExist) {
        const params = {
          tokenKey: this.userLoged.company.stKey,
          cdUser: this.userLoged.idUser,
          serialId: value,
          cdAgent: this.$store.state.cdAgent,
        } as UpdateSetReadAppointmentParams;

        await updateSetReadAppointment(params);

        this.$store.state.appointmentsNotification = this.$store.state.appointmentsNotification.map(
          (ap) => {
            if (ap.id === value) return { ...ap, isRead: true };
            return ap;
          },
        );
      }

      this.setNotificationRead(result);
    },
    moreDetails(data: any) {
      this.$router.push({ name: 'Prod Details', params: { id: data.id, name: data.name } });
    },
    formatNote(): Array<{ id: string; agentId: string }> {
      return this.territories.map((territory) => ({
        id: territory.id,
        agentId: territory.agents[0].id,
        tokenKey: this.userLoged.company.stKey,
      }));
    },
    async setAppointmentInNotification() {
      const tokenKey = this.userLoged.company.stKey.toString();
      const termStatus = {
        cdUser: this.userLoged.idUser,
        tokenKey,
      };

      this.getNotificationAppoint(termStatus);

      await this.getAppointmentRequest({ tokenKey, document: this.userLoged.stDocument });
    },
    createAppointment(score: string, quiz: boolean) {
      const { territories, appointments } = this;
      // eslint-disable-next-line no-restricted-syntax
      for (const territory of territories) {
        const hasAppointment = appointments.some((ap) => ap.cdTerritory === territory.id);
        if (!hasAppointment) {
          const appointment = {
            agentId: territory.agents[0].id,
            territoryId: territory.id,
            appointmentType: 'AutoVistoria',
            url: 'www.teste.com',
            idUser: this.userLoged.idUser,
            tokenKey: this.userLoged.company.stKey,
            score,
            questionQuiz: quiz,
          };
          if (appointment.questionQuiz != null && appointment.score != null) {
            insertAppointment(appointment);
            appointment.appointmentType = 'GeoMonitoramento';
            insertAppointment(appointment);
          }
        }
      }
    },
    onRegisterTerritory() {
      this.$router.push('/produtor/register-territory');
    },
    async onWatch() {
      this.loadingNotificationCenterNotViewed = true;
      this.$watch(
        // @ts-ignore
        (vm) => [vm.getNotificationsUnread, vm.getAppointmentNotification],
        (value) => {
          const [notificationsUnread, appoinments] = value;
          notificationsUnread.forEach((n) => {
            const notification = this.notifications.find((not: any) => not.id === n.id && not.viewed === false);
            if (!notification) {
              this.notifications.push(n);
              const params = {
                tokenKey: this.userLoged.company.stKey,
                to: this.userLoged.stEmail,
                subject: 'Programa de Reinserção e Monitoramento',
                message: `${n.text}<br>
              Atenciosamente,<br>
              Equipe PREM<br>
              <img src=${'https://ci4.googleusercontent.com/proxy/8VXcGgWKgnRWDvoO1ULFanruDLcoCVStB1eOdVwnCvNmdWUUNKVrTbErLmnC-ZkxTcINjM1fhaWew840ultpf0YT4dqaeeJzfqBifhaf_AW2jBUsFcK3iCseHW9TM7VRqhAoTOYZggb-KagRniDYXb0g9vRm76m17MihWEPNTc2fsP-p8pMDe2K3_L7bfEulpvPOGaudQhaYjSFyiw=s0-d-e1-ft#https://docs.google.com/uc?export=download&id=1Jvf12QCtJK5t0pgWs8wJSLXOCvcYKp7q&revid=0B4JMmF9tUiLRT3Y0WlV2RkIxZkR1WThPVEdtMjVrYTlVaVpRPQ'}/>`,
                isNotification: true,
                cdTerritory: n.id.toString(),
                tag: 'Monitoramento',
                cdUser: this.userLoged.idUser.toString(),
              };
              sendEmail(params);
            }
          });
          appoinments.forEach((n) => {
            const notification = this.notifications.find((not: any) => not.id === n.id && not.viewed === false);
            if (!notification) { this.notifications.push(n); }
          });
          if (this.territoriesArray.length > 0) {
            this.loadingNotificationCenterNotViewed = false;
          }
          this.notificationCount = this.$store.state.notificationsUnread.length;
        },
      );
    },
    onObserveStepRegister(cdTerritory: string) {
      this.$router.push({ name: 'StepRegister', query: { cdTerritory } });
    },
    onAcceptNotification(notification: any) {
      this.notificationEntity = {};
      if (!notification.viewed) {
        this.notificationEntity = this.$store.state.notificationsUnread.find((n: any) => n.id === notification.id);
        this.notificationCount -= 1;
      }
      if (notification.viewed) {
        this.notificationEntity = this.$store.state.notificationsRead.find((n: any) => n.id === notification.id);
      }

      const result = this.notifications.map((n: any) => {
        if (n.id === notification.id) {
          const params: ResponseNotificationParams = {
            notificationId: n.id,
            userId: n.userId,
            notificationType: NotificationResponseType.Granted,
            tokenKey: this.userLoged.company.stKey,
          };

          responseNotification(params);
          const { text, type, tag } = switchNotificationType(
            1,
            4,
            {
              issuerName: this.notificationEntity.issuerName,
              territoryName: this.notificationEntity.territoryName,
              date: this.notificationEntity.dtResponse !== null ? this.notificationEntity.dtResponse.calendar() : moment().calendar(),
            },
            false,
          );
          return {
            id: this.notificationEntity.id,
            viewed: true,
            time: this.notificationEntity.dtResponse !== null ? this.notificationEntity.dtResponse.calendar() : moment().calendar(),
            text,
            type: (type as any) ?? undefined,
            tag,
            url: this.notificationEntity.url,
          };
        }
        this.loadingNotificationCenterViewed = false;
        return n;
      });
      this.notifications = result;
    },
    onRefuseNotification(notification: any) {
      this.notificationEntity = {};
      if (!notification.viewed) {
        this.notificationEntity = this.$store.state.notificationsUnread.find((n: any) => n.id === notification.id);
        this.notificationCount -= 1;
      }
      if (notification.viewed) {
        this.notificationEntity = this.$store.state.notificationsRead.find((n: any) => n.id === notification.id);
      }

      const result = this.notifications.map((n: any) => {
        if (n.id === notification.id) {
          const params: ResponseNotificationParams = {
            notificationId: n.id,
            userId: n.userId,
            notificationType: NotificationResponseType.Denied,
            tokenKey: this.userLoged.company.stKey,
          };
          responseNotification(params);
          const { text, type, tag } = switchNotificationType(
            1,
            3,
            {
              issuerName: this.notificationEntity.issuerName,
              territoryName: this.notificationEntity.territoryName,
              date: this.notificationEntity.dtResponse !== null ? this.notificationEntity.dtResponse.calendar() : moment().calendar(),
            },
            false,
          );
          const paramsSend = {
            tokenKey: this.userLoged.company.stKey,
            to: this.userLoged.stEmail,
            subject: 'Programa de Reinserção e Monitoramento',
            message: `${text}<br>
            'Atenciosamente,<br>
            Equipe PREM<br>
            <img src=${'https://ci4.googleusercontent.com/proxy/8VXcGgWKgnRWDvoO1ULFanruDLcoCVStB1eOdVwnCvNmdWUUNKVrTbErLmnC-ZkxTcINjM1fhaWew840ultpf0YT4dqaeeJzfqBifhaf_AW2jBUsFcK3iCseHW9TM7VRqhAoTOYZggb-KagRniDYXb0g9vRm76m17MihWEPNTc2fsP-p8pMDe2K3_L7bfEulpvPOGaudQhaYjSFyiw=s0-d-e1-ft#https://docs.google.com/uc?export=download&id=1Jvf12QCtJK5t0pgWs8wJSLXOCvcYKp7q&revid=0B4JMmF9tUiLRT3Y0WlV2RkIxZkR1WThPVEdtMjVrYTlVaVpRPQ'}/>`,
            isNotification: true,
            cdTerritory: this.notificationEntity.id,
            tag: 'Monitoramento',
            cdUser: this.userLoged.idUser,
          };
          sendEmail(paramsSend);
          return {
            id: this.notificationEntity.id,
            viewed: true,
            time: this.notificationEntity.dtResponse !== null ? this.notificationEntity.dtResponse.calendar() : moment().calendar(),
            text,
            type: (type as any) ?? undefined,
            tag,
            url: this.notificationEntity.url,
          };
        }
        this.loadingNotificationCenterViewed = false;
        return n;
      });
      this.notifications = result;
    },
    async onSetReadNotification(notification: any) {
      if (notification.tag === 'Multa') {
        const { idUser } = this.userLoged;
        const tokenKey = this.userLoged.company.stKey;
        const cdTerritory = notification.id;
        await insertReadNotification(idUser, cdTerritory, tokenKey, true, 'Multa', '1');
        this.$router.push(`/produtor/territory/${notification.id}/${notification.name}`);
      }
      if (notification.tag === 'Gix') {
        const { idUser } = this.userLoged;
        const tokenKey = this.userLoged.company.stKey;
        const cdTerritory = notification.id;
        await insertReadNotification(idUser, cdTerritory, tokenKey, true, 'Gix', '1');
        this.modal = true;
        this.territoryEditionModal = true;
      }
      if (notification.tag === 'Ticket') {
        const { idUser } = this.userLoged;
        const tokenKey = this.userLoged.company.stKey;
        const cdTerritory = notification.id;
        const { ticketId } = notification;
        await insertReadNotification(idUser, cdTerritory, tokenKey, true, 'Ticket', ticketId);
        this.modal = true;
      }
      if (!this.loadingNotificationCenterViewed) {
        this.notificationEntity = {};
        if (!notification.viewed) {
          this.notificationEntity = this.$store.state.notificationsUnread.find((n: any) => n.id === notification.id);
          this.$store.state.notificationsRead.push(this.notificationEntity);
          this.notificationCount -= 1;
        }
        const result = this.notifications.map((n: any) => {
          if (n.id === this.notificationEntity.id) {
            const params: SetReadNotificationParams = {
              notificationId: this.notificationEntity.id,
              userId: this.notificationEntity.userId,
              tokenKey: this.userLoged.company.stKey,
            };
            setReadNotification(params);
            return { ...n, read: true, viewed: true };
          }
          return n;
        });
        this.notifications = result;
      }
    },
    async getNotificationsPayment() {
      const tokenKey = this.userLoged.company.stKey;
      const response = await getContestationAll(tokenKey);
      const document = this.userLoged.stDocument;
      response.forEach((j) => {
        getPenalty(j.cdTerritory).then((e) => {
          if (e.length > 0 && j.document === document) {
            if (this.isReadObj.filter((i) => i.cdTerritory === j.cdTerritory).length > 0) {
              this.notifications.push({
                id: j.cdTerritory,
                name: j.name,
                viewed: true,
                /* eslint newline-per-chained-call: ["error", { "ignoreChainWithDepth": 2 }] */
                time: j.createdOn.slice(0, -15).split('-')
                  .reverse()
                  .join('-')
                  .replaceAll('-', '/')
                  .replaceAll('T', ''),
                idTerritory: j.id,
                text: `Olá ${this.userLoged.stName} A multa do território ${j.name} foi atualizada.
                Clique aqui para gerar gerar os boletos para pagamento da multa!
                Demais informações seguem nos detalhes do território ${j.name}.`,
                type: 'info',
                tag: 'Multa',
                url: 'teste.com',
              });
            } else {
              this.notifications.push({
                id: j.cdTerritory,
                name: j.name,
                viewed: false,
                /* eslint newline-per-chained-call: ["error", { "ignoreChainWithDepth": 2 }] */
                time: j.createdOn.slice(0, -15).split('-')
                  .reverse()
                  .join('-')
                  .replaceAll('-', '/')
                  .replaceAll('T', ''),
                idTerritory: j.id,
                text: `Olá ${this.userLoged.stName} A multa do território ${j.name} foi atualizada.
                Clique aqui para gerar gerar os boletos para pagamento da multa!
                Demais informações seguem nos detalhes do território ${j.name}.`,
                type: 'info',
                tag: 'Multa',
                url: 'teste.com',
              });
              const params = {
                tokenKey: this.userLoged.company.stKey,
                to: this.userLoged.stEmail,
                subject: 'Programa de Reinserção e Monitoramento',
                message: `Olá ${this.userLoged.stName} A multa do território ${j.name} foi atualizada.
                Clique aqui para gerar gerar os boletos para pagamento da multa!
                Demais informações seguem nos detalhes do território ${j.name}.<br>
                Atenciosamente,<br>
                Equipe PREM<br>
                <img src=${'https://ci4.googleusercontent.com/proxy/8VXcGgWKgnRWDvoO1ULFanruDLcoCVStB1eOdVwnCvNmdWUUNKVrTbErLmnC-ZkxTcINjM1fhaWew840ultpf0YT4dqaeeJzfqBifhaf_AW2jBUsFcK3iCseHW9TM7VRqhAoTOYZggb-KagRniDYXb0g9vRm76m17MihWEPNTc2fsP-p8pMDe2K3_L7bfEulpvPOGaudQhaYjSFyiw=s0-d-e1-ft#https://docs.google.com/uc?export=download&id=1Jvf12QCtJK5t0pgWs8wJSLXOCvcYKp7q&revid=0B4JMmF9tUiLRT3Y0WlV2RkIxZkR1WThPVEdtMjVrYTlVaVpRPQ'}/>`,
                isNotification: true,
                cdTerritory: j.cdTerritory,
                tag: 'Contestation',
                cdUser: this.userLoged.idUser.toString(),
              };
              sendEmail(params);
            }
          }
        });
      });
    },
    async getNotificationReadMonitoring() {
      this.loadingNotificationCenterViewed = true;
      const params: GetNotificationParams = {
        userId: this.$store.state.userLogged.idUser,
        tokenKey: this.$store.state.userLogged.company.stKey,
        typeUser: 'PROD',
      };

      await getNotificationRead(params).then((data) => {
        this.setNotificationRead(Array.isArray(data) ? data : []);
      });
      const notificationsRead = this.getNotificationsRead;
      if (notificationsRead.length > 0) {
        notificationsRead.forEach((n) => {
          this.notifications.push(n);
        });
      }
      this.loadingNotificationCenterViewed = false;
    },
    async notificationRead(value: number) {
      const { notificationsUnread } = this.$store.state;
      notificationsUnread.map(async (notification: any) => {
        if (notification.id === value) {
          const data = {
            frigId: notification.frigId.toString(),
            territoryId: notification.territoryId.toString(),
            status: StatusTerritoryAccess.granted,
            tokenKey: this.userLoged.company.stKey,
          };

          await this.changeStatusNotification(data);
          sendEmail({
            tokenKey: this.userLoged.company.stKey,
            to: notification.frigEmail,
            subject: 'Solicitação do território',
            message: `O produtor ${this.userLoged.stName} do território ${notification.territoryName} aceitou sua solicitação.`,
            isNotification: true,
            cdTerritory: notification.territoryId.toString(),
            tag: 'Solicitation',
            cdUser: this.userLoged.idUser.toString,
          });

          return { ...notification, status: StatusTerritoryAccessNumber.granted };
        }
        return notification;
      });
    },
    async reloadNotificationUnread() {
      this.loadingNotificationCenterNotViewed = true;
      const params: GetNotificationParams = {
        userId: this.$store.state.userLogged.idUser,
        tokenKey: this.$store.state.userLogged.company.stKey,
        typeUser: 'PROD',
      };

      await getNotificationUnread(params).then((data) => {
        this.setNotificationUnread(Array.isArray(data) ? data : []);
      });
      const notificationsUnread = this.getNotificationsUnread;
      if (notificationsUnread.length > 0) {
        notificationsUnread.forEach((n) => {
          const newNotification = this.$store.state.notificationsUnread.filter((not) => not.id === n.id);
          if (!newNotification) {
            this.notifications.push(n);
          }
        });
      }
      this.loadingNotificationCenterNotViewed = false;
    },
    async getTerritoryRequest() {
      this.loading = true;
      const formattedValue = formatStringOnlyNumbers(this.userLoged.stDocument);
      this.loadingNotificationCenterNotViewed = true;
      this.territoriesArray = await getTerritoryByAgentDocumentService(
        formattedValue,
        '',
        TerritoryStatus.provisional,
        false,
      );
      if (this.territoriesArray.length > 0) {
        this.loadingNotificationCenterNotViewed = false;
      }
      this.createAppointment('B', true);
      this.territoriesArray.forEach((e) => {
        const params = {
          tokenKey: this.userLoged.company.stKey,
          cdTerritory: e.id,
        };
        // updateStatusTerritoryOfficial(e.id, 'INATIVO');
        getTicket({ cdTerritory: e.id }).then((j) => {
          const date = new Date() as any;
          const today = date.getDate();
          const monthDay = date.getMonth();
          const years = date.getFullYear();
          j.objectResult.forEach((element) => {
            const dt = new Date(element.dueDate) as any;
            // const formated = moment(dt).format('YYYY-MM-DD');
            const day = dt.getDate();
            const month = dt.getMonth();
            const yearsData = dt.getFullYear();
            const diffInMs = date - dt;
            const diffDays = dt - date;
            const diffDaysDt = diffDays / (1000 * 60 * 60 * 24);
            const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
            if (diffDaysDt >= 4 && diffDaysDt < 5 && yearsData === years) {
              if (this.isReadObjTicket.filter((i) => i.ticketId === element.ticketId && i.tag === 'Ticket').length > 0) {
                this.notifications.push({
                  id: element.cdTerritory,
                  name: element.ticketName,
                  viewed: true,
                  time: element.dueDate.slice(0, -9).split('-')
                    .reverse()
                    .join('-')
                    .replaceAll('-', '/'),
                  idTerritory: element.cdTerritory,
                  text: `Olá ${this.userLoged.stName}! Faltam 5 dias para o vencimento da sua parcela, pague o boleto ${element.ticketName}`,
                  type: 'info',
                  tag: 'Ticket',
                  url: 'teste.com',
                  ticketId: element.ticketId,
                });
              } else {
                this.notifications.push({
                  id: element.cdTerritory,
                  name: element.ticketName,
                  viewed: false,
                  time: element.dueDate.slice(0, -9).split('-')
                    .reverse()
                    .join('-')
                    .replaceAll('-', '/'),
                  idTerritory: element.cdTerritory,
                  text: `Olá ${this.userLoged.stName}! Faltam 5 dias para o vencimento da sua parcela, pague o boleto ${element.ticketName} `,
                  type: 'info',
                  tag: 'Ticket',
                  url: 'teste.com',
                  ticketId: element.ticketId,
                });
                const params = {
                  tokenKey: this.userLoged.company.stKey,
                  to: this.userLoged.stEmail,
                  subject: 'Programa de Reinserção e Monitoramento',
                  message: `Olá ${this.userLoged.stName}! Faltam 5 dias para o vencimento da sua parcela, pague o boleto ${element.ticketName}.<br>
                  Atenciosamente,<br>
                  Equipe PREM<br>
                  <img src=${'https://ci4.googleusercontent.com/proxy/8VXcGgWKgnRWDvoO1ULFanruDLcoCVStB1eOdVwnCvNmdWUUNKVrTbErLmnC-ZkxTcINjM1fhaWew840ultpf0YT4dqaeeJzfqBifhaf_AW2jBUsFcK3iCseHW9TM7VRqhAoTOYZggb-KagRniDYXb0g9vRm76m17MihWEPNTc2fsP-p8pMDe2K3_L7bfEulpvPOGaudQhaYjSFyiw=s0-d-e1-ft#https://docs.google.com/uc?export=download&id=1Jvf12QCtJK5t0pgWs8wJSLXOCvcYKp7q&revid=0B4JMmF9tUiLRT3Y0WlV2RkIxZkR1WThPVEdtMjVrYTlVaVpRPQ'}/>`,
                  isNotification: true,
                  cdTerritory: element.cdTerritory,
                  tag: 'Multa',
                  cdUser: this.userLoged.idUser.toString(),
                };
                sendEmail(params);
              }
            }
            if (day === today && yearsData === years && monthDay === month) {
              if (this.isReadObjTicket.filter((i) => i.ticketId === element.ticketId && i.tag === 'Ticket').length > 0) {
                this.notifications.push({
                  id: element.cdTerritory,
                  name: element.ticketName,
                  viewed: true,
                  time: element.dueDate.slice(0, -9).split('-')
                    .reverse()
                    .join('-')
                    .replaceAll('-', '/'),
                  idTerritory: element.cdTerritory,
                  text: `Olá ${this.userLoged.stName}!  O vencimento da sua parcela atual é hoje! Pague o boleto ${element.ticketName} hoje.`,
                  type: 'info',
                  tag: 'Ticket',
                  url: 'teste.com',
                  ticketId: element.ticketId,
                });
              } else {
                this.notifications.push({
                  id: element.cdTerritory,
                  name: element.ticketName,
                  viewed: false,
                  time: element.dueDate.slice(0, -9).split('-')
                    .reverse()
                    .join('-')
                    .replaceAll('-', '/'),
                  idTerritory: element.cdTerritory,
                  text: `Olá produtor!, sua parcela do boleto ${element.ticketName} vence hoje!`,
                  type: 'info',
                  tag: 'Ticket',
                  url: 'teste.com',
                  ticketId: element.ticketId,
                });
                const params = {
                  tokenKey: this.userLoged.company.stKey,
                  to: this.userLoged.stEmail,
                  subject: 'Programa de Reinserção e Monitoramento',
                  message: `Olá ${this.userLoged.stName}!  O vencimento da sua parcela atual é hoje! Pague o boleto ${element.ticketName} hoje.<br>
                  Equipe PREM<br>
                  <img src=${'https://ci4.googleusercontent.com/proxy/8VXcGgWKgnRWDvoO1ULFanruDLcoCVStB1eOdVwnCvNmdWUUNKVrTbErLmnC-ZkxTcINjM1fhaWew840ultpf0YT4dqaeeJzfqBifhaf_AW2jBUsFcK3iCseHW9TM7VRqhAoTOYZggb-KagRniDYXb0g9vRm76m17MihWEPNTc2fsP-p8pMDe2K3_L7bfEulpvPOGaudQhaYjSFyiw=s0-d-e1-ft#https://docs.google.com/uc?export=download&id=1Jvf12QCtJK5t0pgWs8wJSLXOCvcYKp7q&revid=0B4JMmF9tUiLRT3Y0WlV2RkIxZkR1WThPVEdtMjVrYTlVaVpRPQ'}/>`,
                  isNotification: true,
                  cdTerritory: element.cdTerritory,
                  tag: 'Boleto',
                  cdUser: this.userLoged.idUser.toString(),
                };
                sendEmail(params);
              }
            }
            if (diffInDays >= 1 && diffInDays < 2 && yearsData === years) {
              if (this.isReadObjTicket.filter((i) => i.ticketId === element.ticketId && i.tag === 'Ticket').length > 0) {
                this.notifications.push({
                  id: element.cdTerritory,
                  name: element.ticketName,
                  viewed: true,
                  time: element.dueDate.slice(0, -9).split('-')
                    .reverse()
                    .join('-')
                    .replaceAll('-', '/'),
                  idTerritory: element.cdTerritory,
                  text: `Olá ${this.userLoged.stName}!  O vencimento da sua parcela atual é hoje! Pague o boleto ${element.ticketName} hoje.`,
                  type: 'info',
                  tag: 'Ticket',
                  url: 'teste.com',
                  ticketId: element.ticketId,
                });
              } else {
                this.notifications.push({
                  id: element.cdTerritory,
                  name: element.ticketName,
                  viewed: false,
                  time: element.dueDate.slice(0, -9).split('-')
                    .reverse()
                    .join('-')
                    .replaceAll('-', '/'),
                  idTerritory: element.cdTerritory,
                  text: `Olá ${this.userLoged.stName}!  O vencimento da sua parcela atual é hoje! Pague o boleto ${element.ticketName} hoje.`,
                  type: 'info',
                  tag: 'Ticket',
                  url: 'teste.com',
                  ticketId: element.ticketId,
                });
                const params = {
                  tokenKey: this.userLoged.company.stKey,
                  to: this.userLoged.stEmail,
                  subject: 'Programa de Reinserção e Monitoramento',
                  message: `Olá ${this.userLoged.stName}!  O vencimento da sua parcela atual é hoje! Pague o boleto ${element.ticketName} hoje.<br>
                Equipe PREM<br>
                <img src=${'https://ci4.googleusercontent.com/proxy/8VXcGgWKgnRWDvoO1ULFanruDLcoCVStB1eOdVwnCvNmdWUUNKVrTbErLmnC-ZkxTcINjM1fhaWew840ultpf0YT4dqaeeJzfqBifhaf_AW2jBUsFcK3iCseHW9TM7VRqhAoTOYZggb-KagRniDYXb0g9vRm76m17MihWEPNTc2fsP-p8pMDe2K3_L7bfEulpvPOGaudQhaYjSFyiw=s0-d-e1-ft#https://docs.google.com/uc?export=download&id=1Jvf12QCtJK5t0pgWs8wJSLXOCvcYKp7q&revid=0B4JMmF9tUiLRT3Y0WlV2RkIxZkR1WThPVEdtMjVrYTlVaVpRPQ'}/>`,
                  isNotification: true,
                  cdTerritory: element.cdTerritory,
                  tag: 'Boleto',
                  cdUser: this.userLoged.idUser.toString(),
                };
                sendEmail(params);
              }
            }
          });
        });
        generateLinkGix(params).then((data) => {
          if (data[data.length - 1]?.url !== null) {
            this.linkGix = data[data.length - 1]?.url;
          }
          getTicket({ cdTerritory: e.id }).then((k) => {
            if (this.isReadObj.filter((i) => i.cdTerritory === e.id && i.tag === 'Gix').length > 0 && k.message === 'Boletos encontrados.') {
              this.notifications.push({
                id: e.id,
                name: e.name,
                viewed: true,
                time: this.isReadObj.dateSolicitation,
                idTerritory: e.id,
                text: `Olá Produtor ${this.userLoged.stName}! Acesse o link da jornada no GIX através de um dispositivo móvel para realizar sua primeira autovistoria do território ${e.name}. Clique aqui para mais detalhes!`,
                type: 'info',
                tag: 'Gix',
                url: data[data.length - 1]?.url,
              });
            } else if (k.message === 'Boletos encontrados.') {
              this.notifications.push({
                id: e.id,
                name: e.name,
                viewed: false,
                time: moment().calendar(),
                idTerritory: e.id,
                text: `Olá Produtor ${this.userLoged.stName}! Acesse o link da jornada no GIX através de um dispositivo móvel para realizar sua primeira autovistoria do território ${e.name}. Clique aqui para mais detalhes`,
                type: 'info',
                tag: 'Gix',
                url: data[data.length - 1]?.url,
              });
              const params = {
                tokenKey: this.userLoged.company.stKey,
                to: this.userLoged.stEmail,
                subject: 'Programa de Reinserção e Monitoramento',
                message: `Olá Produtor ${this.userLoged.stName}! Acesse o link da jornada no GIX através de um dispositivo móvel para realizar sua primeira autovistoria do território ${e.name}. Clique aqui para mais detalhes.<br>
                <a href=${data[data.length - 1]?.url}>Link do Gix</a><br>
                Atenciosamente,<br>
                Equipe PREM<br>
                <img src=${'https://ci4.googleusercontent.com/proxy/8VXcGgWKgnRWDvoO1ULFanruDLcoCVStB1eOdVwnCvNmdWUUNKVrTbErLmnC-ZkxTcINjM1fhaWew840ultpf0YT4dqaeeJzfqBifhaf_AW2jBUsFcK3iCseHW9TM7VRqhAoTOYZggb-KagRniDYXb0g9vRm76m17MihWEPNTc2fsP-p8pMDe2K3_L7bfEulpvPOGaudQhaYjSFyiw=s0-d-e1-ft#https://docs.google.com/uc?export=download&id=1Jvf12QCtJK5t0pgWs8wJSLXOCvcYKp7q&revid=0B4JMmF9tUiLRT3Y0WlV2RkIxZkR1WThPVEdtMjVrYTlVaVpRPQ'}/>`,
                isNotification: true,
                cdTerritory: e.id,
                tag: 'Gix',
                cdUser: this.userLoged.idUser.toString(),
              };
              sendEmail(params);
            }
          });
        });
      });
      this.loading = false;
    },
  },
  async created() {
    const res = await getDocumentPaliative(this.userLoged.company.stKey.toString(), this.userLoged.stEmail);
    if (this.userLoged.stDocument === '' || this.userLoged.stDocument === null) {
      this.userLoged = JSON.parse(sessionStorage.getItem('userLogged') as string);
      this.userLoged.stDocument = res.document;
      await putDocumentPaliative(this.userLoged.company.stKey.toString(), this.userLoged.stEmail, res.document);
      sessionStorage.setItem('userLogged', JSON.stringify(this.userLoged));
    }
    const { idUser } = this.userLoged;
    const data = await getReadNotification(idUser);
    const noDuplicate = data;
    const reduced = [];
    noDuplicate.objectResult.forEach((item: any) => {
      const duplicated = reduced.findIndex((redItem) => {
        // @ts-ignore
        return item.ticketId === redItem.ticketId;
      }) > -1;
      if (!duplicated) {
        // @ts-ignore
        reduced.push(item);
      }
    });
    this.isReadObjTicket = reduced;
    data.objectResult.forEach((item: any) => {
      const duplicated = reduced.findIndex((redItem) => {
        // @ts-ignore
        return item.ticketId === redItem.ticketId;
      }) > -1;
      if (!duplicated) {
        // @ts-ignore
        reduced.push(item);
      }
    });
    this.isReadObj = data.objectResult;
    // @ts-ignore
    this.$store.state.isFrig = false;
    const termStatus = {
      cdUser: this.userLoged.idUser,
      tokenKey: this.userLoged.company.stKey.toString(),
    };
    await this.getStatusbycdUser(termStatus);
    this.modalAddAgent = !this.$store.state.statusGet.status;
    // @ts-ignore
    this.createAppointment();
  },
  async mounted() {
    StartBlip();
    this.$store.state.isFrig = false;
    const termStatus = {
      cdUser: this.userLoged.idUser,
      tokenKey: this.userLoged.company.stKey.toString(),
    };
    await this.getStatusbycdUser(termStatus);
    this.modalAddAgent = !this.$store.state.statusGet.status;
    this.onWatch();
    this.getNotificationReadMonitoring();
    this.getNotificationsPayment();
    this.setAppointmentInNotification();
    this.getTerritoryRequest();
    const userVouchersResponse = await getUserVoucherAvailability();
    this.setVoucherUsability(userVouchersResponse.usabilityAvailable);
  },
});
